<template>
   <p class="tag label" >
      <slot></slot>
   </p>
</template>

<script setup lang="ts">
// const emit = defineEmits(["handleClick"]);
const props = defineProps({
   
})
</script>

<style lang="scss" scoped>
@import "~/assets/scss/partials/tags";
</style>